<template>
	<div class="ct-contact">
		<div class="row">
            <form class="col s12" id="contactForm" method="post" v-on:submit.prevent="validateForm">
                <div class="row">
                    <div class="input-field col s12 m6">
                        <i class="material-icons prefix">account_circle</i>
                        <input id="nom" type="text" class="validate" v-model="nom">
                        <label for="nom">Nom Prénom</label>
                    </div>
                    <div class="input-field col s12 m6">
                        <i class="material-icons prefix">phone</i>
                        <input id="telephone" type="text" class="validate" v-model="telephone">
                        <label for="telephone">Téléphone</label>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col s12">
                        <i class="material-icons prefix">email</i>
                        <input id="email" type="email" class="validate" v-model="email">
                        <label for="email" data-error="wrong" data-success="right">Email</label>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col s12">
                        <i class="material-icons prefix">edit</i>
                        <input id="sujet" type="text" class="validate" v-model="sujet">
                        <label for="sujet">Sujet</label>
                    </div>
                </div>
                <div class="row">
                    <div class="input-field col s12">
                        <i class="material-icons prefix">edit</i>
                        <textarea id="demande" class="materialize-textarea" v-model="demande"></textarea>
                        <label for="demande">Demande</label>
                    </div>
                </div>
                <div class="row ct-contact-bouton-position">
                    <div class="col s12">
                        <div id="success"></div>
                        <!-- type="submit" -->
                        <button class="ct-bouton btn waves-effect waves-light" name="action" type="submit">Envoyer  
                            <i class="material-icons right">send</i>
                        </button>
                    </div>
                </div>

                <div class="col s12 center" v-if="posted">
                    <h3>Votre demande a bien été envoyée.</h3>
                </div> 

                <div class="col s12 center" v-if="missing">
                    <h3>Veuillez vérifier votre saisie.</h3>
                </div> 
            </form>
        </div>
	</div>
</template>

<script>
    
    import axios from 'axios'

	export default {
		name: 'CtContact',
		data() {
			return {
                msg: 'Contact',
                nom: '',
                telephone: '',
                email: '',
                sujet: '',
                demande: '',
                missing: false,
                posted: false
			}
        },
        computed: {
            missingNom: function () { return this.nom === ''; },
            missingEmail: function () { return (this.isEmail(this.email) === null) },
            missingSujet: function () { return this.sujet === ''; },
            missingDemande: function () { return this.demande === ''; }
        },
        methods: {
            isEmail: (str) => {      
                let regexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/     
                return str.match(regexp);
            },
            validateForm: function (event) {
                console.log(this.missing)
                console.log(this.posted)
                if (this.missingNom || this.missingEmail || this.missingSujet || this.missingDemande) {
                    this.missing = true
                    event.preventDefault();
                } else {
                    this.onSubmit();
                }
            },
            onSubmit () {
                axios.post('php/post.php', {
                            'nom': this.nom,
                            'telephone': this.telephone,
                            'email': this.email,
                            'sujet': this.sujet,
                            'demande': this.demande               
                    }).then(response => {
                        if (response.data.error) {
                            console.log('error', response.data.error)
                        } else {
                            this.posted = true
                            console.log('success', response.data.message)                   
                        }
                    }).catch(error => {
                        console.log(error.response)
                }); 
            }
        },
	}
</script>
<style>

    .ct-contact {
        display: flex;
        margin: 30px;
    }

    .ct-contact-bouton-position {
        /* display: flex;
        align-content: center; */
        text-align: center;
    }

   .input-field input[type=text]:focus + label {
        color: #B0E900!important;
    }

   .input-field input[type=text]:focus {
        border-bottom: 1px solid #B0E900!important;
        box-shadow: 0 1px 0 0 #B0E900!important;
    }

   .input-field input[type=email]:focus + label {
        color: #B0E900!important;
    }

   .input-field input[type=email]:focus {
        border-bottom: 1px solid #B0E900!important;
        box-shadow: 0 1px 0 0 #B0E900!important;
    }

    .btn:active {
        color: #FFF!important;
        background-color: #B0E900;
    }

    .btn:focus{ 
        color: #B0E900; 
        background-color: #4B4B4B;
    }

    textarea.materialize-textarea:focus + label {
        color: #B0E900!important;
    }

    textarea.materialize-textarea:focus {
        border-bottom: 1px solid #B0E900!important;
        box-shadow: 0 1px 0 0 #B0E900!important;
    }    

    .input-field .prefix.active {
        color: #B0E900!important;
    }

</style>



// WEBPACK FOOTER //
// src/components/CtContact.vue